import React, { useState } from "react";
import ReactDatePicker from "react-datepicker";
import { Field, useField } from "formik";
import { BsFillCalendarWeekFill, BsFillCalendarEventFill } from "react-icons/bs";
import FieldError from "../../shared/FieldError";

const SelectDate = ({ setFieldValue, values, ...props }) => {
  const [field, meta, helpers] = useField(props);
  const { setTouched } = helpers;

  const [dateRange, setDateRange] = useState([null, null]);
  const [dateType, setDateType] = useState(
    props.dateType == "specific" ? "specific" :
    values.request_date_start && !values.request_date_end
      ? "specific"
      : !values.request_date_start && !values.request_date_end && !props.isNew
      ? "range"
      : values.request_date_start && values.request_date_end
      ? "range"
      : ""
  );
  const [startDate, endDate] = dateRange;

  return (
    <>
      <label>{ props.fieldLabel || "Request Date(s) & Time" }</label>
      <small id="from">{ props.fieldDescription || "Please select a date type for the request" }</small>
      <br />

      <div className="flex">
        {props.dateType != 'specific' && (<select
          className={"date-type"}
          name={"date_type"}
          onChange={(e) => {
            setFieldValue("request_date_start", "");
            setFieldValue("date_type", e.target.value);
            setFieldValue("date", "");
            setFieldValue("request_date_end", "");
            e.target.value == "range" ? setDateType("range") : setDateType("specific");
          }}
          value={dateType}
        >
          <option value={""}>{"Choose a date type"}</option>
          <option value={"specific"}>{"Patient has a specific date request"}</option>
          <option value={"range"}>{"Patient will take any appointment within range"}</option>
        </select>)}{" "}
        {dateType == "specific" && (
          <>
            <div className={"flex datefield-wrapper"}>
              <Field name="date">
                {({ field, meta }) => {
                  return (
                    <>
                      <BsFillCalendarEventFill className="calendar-icon" />
                      <ReactDatePicker
                        className="datepicker"
                        autoComplete="off"
                        {...field}
                        dateFromat={"YYYY-MM-dd"}
                        onChange={(date) => {
                          setTouched(true);
                          setFieldValue("request_date_start", date);
                          setFieldValue("request_date", date);
                          if (props.fieldValueName) {
                            setFieldValue(props.fieldValueName, date.toISOString().slice(0, 10));
                          }
                          setFieldValue("date", date.toISOString().slice(0, 10));
                        }}
                      />
                    </>
                  );
                }}
              </Field>
            </div>
            {meta.touched && meta.error ? <FieldError error={meta.error} /> : null}
          </>
        )}
        {dateType == "range" && (
          <div className={"flex datefield-wrapper"}>
            <Field name="date">
              {({ field, meta }) => {
                return (
                  <>
                    <BsFillCalendarWeekFill className="calendar-icon" />
                    <ReactDatePicker
                      id="range"
                      className="datepicker"
                      autoComplete="off"
                      {...field}
                      required={props.required}
                      startDate={startDate}
                      endDate={endDate}
                      dateFromat="YYYY-MM-dd"
                      selectsRange={true}
                      onChange={(update) => {
                        setTouched(true);
                        setDateRange(update);
                        if (update[0] && update[1]) {
                          setFieldValue("request_date_start", update[0]);
                          setFieldValue("request_date_end", update[1]);
                          setFieldValue(
                            "date",
                            update[0].toISOString().slice(0, 10) +
                              " to " +
                              update[1].toISOString().slice(0, 10)
                          );
                        }
                      }}
                    />
                  </>
                );
              }}
            </Field>
          </div>
        )}{" "}
      </div>
    </>
  );
};

export default SelectDate;
